export const apiConstants = {
  url: "/api/courseType"
};
